/**
 * EngagementSunset.jsx — Subtab XIII
 */

import React from "react";
import { CryptoShred } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function EngagementSunset() {
  return (
    <article>
      <SubtabHeading roman="XIII">Engagement Sunset and Data Lifecycle</SubtabHeading>
      <CryptoShred />
      <GapBlock>
        When an engagement ends, client data must be returned or destroyed
        under defined protocols. The technical infrastructure must support
        clean termination.
      </GapBlock>
      <SolutionLead>
        A defined sunset workflow specified in the engagement letter and
        supported by infrastructure design.
      </SolutionLead>
      <Body>
        <P>
          At engagement close, the engaging firm has 30 days to request return
          of client data or to specify destruction. Return is via signed,
          encrypted media transferred through chain-of-custody (the same
          diode-mediated process used for inbound updates, run in reverse for
          this specific event with dual authorization). Destruction follows
          the NIST 800-88 protocols described above.
        </P>
        <P>
          Matter-specific encryption keys held in the HSM are zeroized
          cryptographically on engagement close, rendering the matter's data
          unrecoverable even from backup media. This is "crypto-shredding" and
          is recognized by NIST as a valid sanitization technique for properly
          key-managed encrypted data — it gives CoConsoleX a defensible answer
          to "how do we know our data is gone" without requiring physical
          destruction of every backup tape that ever held the encrypted
          ciphertext.
        </P>
        <P>
          A certificate of destruction is delivered to the engaging firm
          within 60 days of engagement close, signed by the supervising
          attorney and the technical operations lead. The certificate
          identifies what was destroyed, when, by what method, and witnessed
          by whom. This document is what the engaging firm hands to its
          client when the client asks "what happened to our data when the
          engagement ended."
        </P>
        <P>
          CoConsoleX retains operational metadata (engagement dates, billing
          records, conflict-check records) for the period required by
          professional responsibility rules — typically seven to ten years
          depending on jurisdiction — but this metadata excludes substantive
          client information and is itself stored in the air-gapped
          environment under the same controls.
        </P>
        <P>
          For matters under continuing litigation hold at engagement close,
          destruction is suspended until the hold is released, with the
          engaging firm's legal hold notice serving as the controlling
          document. This is standard records-retention practice and CoConsoleX
          specifies it explicitly to avoid spoliation risk.
        </P>
      </Body>
    </article>
  );
}
